import { render, staticRenderFns } from "./AccountingComponent.vue?vue&type=template&id=f70575ca&scoped=true&"
import script from "./AccountingComponent.vue?vue&type=script&lang=ts&"
export * from "./AccountingComponent.vue?vue&type=script&lang=ts&"
import style0 from "./AccountingComponent.vue?vue&type=style&index=0&id=f70575ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70575ca",
  null
  
)

export default component.exports